import { render, staticRenderFns } from "./navLinks.vue?vue&type=template&id=bf230b72&scoped=true&"
import script from "./navLinks.vue?vue&type=script&lang=js&"
export * from "./navLinks.vue?vue&type=script&lang=js&"
import style0 from "./navLinks.vue?vue&type=style&index=0&id=bf230b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf230b72",
  null
  
)

export default component.exports